<template>
    <div class="achieve_back" style="background-color: #275ba9">
        <HeaderNav v-if="!isWeixinBrowser()" navtitle="我的成就" :beforecolor="'#fff'" :backcolor="'#275ba9'" @returnBack="goToBack"></HeaderNav>
        <div class="score_content" :style="{top: (getStateHeight() + 10)+'px'}" style="right: 20px;z-index: 9999; position: fixed;" v-if="totalStarCount > 0">
            <img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span>
        </div>

        <!-- 单个勋章 -->
        <div class="single_medal" v-if="!isEmpty(objMedal)" @touchmove.prevent>
            <div class="back_nav2" :style="{top: getStateHeight()+'px'}" v-on:click.stop="closeMedal"><img src="@/Images/icon_close.png"/></div>

            <img class="program_blur_backgroud"/>
            <div class="back_cover" :style="{backgroundColor: isEmpty(objMedal.time) ? '#0000009f' : ''}"></div>

            <!-- 勋章 -->
            <div class="medal_picture"><img :src="geneNetworkPicture(objMedal.picture)" /></div>

            <!-- 条件或获得日期 -->
            <div v-if="isEmpty(objMedal.time)">
                <div class="need_star">需要{{objMedal.starCount}}颗星星兑换</div>
                <div class="need_lesson">完成{{objMedal.requiredLessonCount}}节课后解锁</div>
            </div>
            <div class="time" v-else>
                {{objMedal.time}} 获得
            </div>

            <!-- 兑换按钮 -->
            <div v-if="isEmpty(objMedal.time)" @click="exchangeClick()" :class="totalStarCount >= objMedal.starCount && englishProgramProgress.finishLessonCount >= objMedal.requiredLessonCount ? 'exchange can_exchange' : 'exchange cannot_exchange'">
                去兑换
            </div>
        </div>

        <!-- 兑换成功提示 -->
        <audio v-show="false" :src="successAudio" id="great_audio"/>
        <div class="exchange_sucess" v-if="isExchangeSucess">
            <div class="div_icon">
                <img id="success_icon" style="display: none" class="icon" src="@/Images/exchange_success.png"/>
            </div>
            <div class="text">
                <span>兑换成功!</span>
            </div>
        </div>

        <div class="course_summary">
            <div class="summary" v-if="!isEmpty(englishProgramProgress)">
                <div class="third_part">
                    <div class="title">完成课程</div>
                    <div class="content"><span>{{englishProgramProgress.finishLessonCount}}</span>
                        <div class="unit">节</div>
                    </div>
                </div>
                <div class="third_part">
                    <div class="title">词汇</div>
                    <div class="content"><span>{{englishProgramProgress.wordCount}}</span>
                        <div class="unit">个</div>
                    </div>
                </div>
                <div class="third_part">
                    <div class="title">学习天数</div>
                    <div class="content"><span>{{englishProgramProgress.studyDayCount}}</span>
                        <div class="unit">天</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="medal_list">
            <div class="group" v-for="(item, index) in listGroup" :key="index">
                <div class="medal_count">{{item.starCount}}颗星兑换</div>
                <div class="unlock">完成{{item.requiredLessonCount}}节课后解锁</div>

                <div class="medal" v-for="(item1, index1) in item.medalList" :key="index1" @click="singleMedalClick(item1)">
                    <img :src="$qiNiuDomainBase + item1.picture" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {Toast} from "mint-ui";
    import $ from "jquery";
    import Vue from "vue";

    export default {
        data() {
            return {
                englishProgramProgress: null,
                listGroup: [],
                totalStarCount: 0,
                objMedal: null,
                isExchangeSucess: false,
                successAudio: 'https://img.xiaohuasheng.cn/exchange_success.mp3',
            }
        },
        methods: {
            goToBack() {
                this.$router.go(-1);
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            singleMedalClick: function (item) {
                this.objMedal = item;
            },
            closeMedal: function () {
                this.objMedal = null;
            },
            exchangeClick: function () {
                let that = this;

                if (that.isEmpty(that.objMedal) ||
                    that.totalStarCount < that.objMedal.starCount ||
                    that.englishProgramProgress.finishLessonCount < that.objMedal.requiredLessonCount) {
                    return;
                }

                let vPk = that.objMedal.id;
                let url = "englishProgram/exchangeMedal/" + vPk;
                this.$axios.get(url).then((response) => {
                    let exchangeResult = response.data;

                    if (exchangeResult === 1) {
                        that.isExchangeSucess = true;
                        that.totalStarCount -= that.objMedal.starCount;
                        that.objMedal = null;
                        that.refreshSingleMedal(vPk);

                        setTimeout(function () {
                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();
                            $("#success_icon").show(800, function(){});
                        }, 20);
                        setTimeout(function () {
                            that.isExchangeSucess = false;
                        }, 3000);
                    } else {
                        Toast("勋章兑换失败");
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            refreshSingleMedal: function(pk) {
                let that = this;
                let url = "englishProgram/getSingleMedal/" + pk;
                this.$axios.get(url).then((response) => {
                    let vMedal = response.data;

                    if (!that.isEmpty(vMedal)) {
                        that.listGroup.forEach((item) => {
                            item.medalList.forEach((medal, index1) => {
                                if (medal.id === pk) {
                                    medal.picture = vMedal.picture;
                                    medal.time = vMedal.time;
                                    Vue.set(item.medalList, index1, medal);
                                }
                            });
                        });

                        setTimeout(function () {
                            if (!that.isEmpty(vMedal)) {
                                that.singleMedalClick(vMedal);
                            }
                        }, 2800);
                    }
                }).catch(function (error) {
                    window.console.log(error);
                });
            },
        },
        beforeCreate() {
            let url = "englishProgram/getUserProgress";
            let that = this;

            this.$axios.get(url).then((response) => {
                that.englishProgramProgress = response.data;
                that.totalStarCount = that.englishProgramProgress.totalStarCount;
            }).catch(function (error) {
                window.console.log(error)
            });

            let url1 = "englishProgram/getMedal";

            this.$axios.get(url1).then((response) => {
                that.listGroup = response.data;
            }).catch(function (error) {
                window.console.log(error)
            });

        },
    }
</script>

<style scoped>
    .course_summary {
        width: 100%;
        background-color: #275ba9;
    }
    .course_summary .summary {
        width: calc(100vmin - 40px);
        background-color: #3333339a;
        margin: 10px 20px 20px 20px;
        display: inline-flex;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .third_part {
        width: calc((100vmin - 40px)/3);
        color: white;
        font-size: 13px;
        display: block;
    }
    .third_part .title {
        width: calc((100vmin - 40px)/3);
        text-align: center;
        margin-top: 15px;
    }
    .third_part .content {
        width: calc((100vmin - 40px)/3);
        margin-bottom: 15px;
        margin-top: 5px;
        display: inline-flex;
        justify-content: center;
        align-items: flex-end;
    }
    .third_part .content span {
        font-size: 25px;
        font-family: "微软雅黑", sans-serif;
    }
    .third_part .content .unit {
        margin-left: 2px;
        padding-bottom: 4px;
    }

    .medal_list {
        padding-bottom: 100px;
        background-color: white;
    }
    .medal_list .group {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 50px;
    }
    .medal_list .group .medal_count {
        width: 100%;
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        margin-top: 30px;
    }
    .medal_list .group .unlock {
        width: 100%;
        color: #999999;
        font-size: 15px;
        text-align: center;
        margin-top: 5px;
    }
    .medal_list .medal {
        width: 33.3vmin;
    }
    .medal_list .medal img {
        width: 90px;
        height: 90px;
        margin-left: calc((33.3vmin - 90px)/2);
        margin-top: 30px;
    }

    .single_medal {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1003;
    }
    .single_medal .back_nav2 {
        width: 44px;
        height: 44px;
        position: absolute;
        left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .single_medal .back_nav2 img {
        width: 25px;
        height: 25px;
    }
    .program_blur_backgroud {
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: -10;
        background-color: #2D4D9AF2;
        overflow-x: hidden;
        overflow-y: hidden;
    }
    .back_cover {
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        z-index: -9;
        border: 1px solid #000000;
    }
    .single_medal .medal_picture {
        margin-top: 20vmax;
    }
    .single_medal .medal_picture img {
        width: 160px;
        height: 160px;
        margin-left: calc(50vmin - 80px);
    }
    .single_medal .need_star {
        width: 100%;
        color: white;
        font-size: 17px;
        text-align: center;
        margin-top: 20px;
    }
    .single_medal .need_lesson {
        width: 100%;
        color: #999999;
        font-size: 14px;
        text-align: center;
        margin-top: 5px;
    }
    .single_medal .time {
        width: 100%;
        color: #999999;
        text-align: center;
        font-size: 15px;
        margin-top: 20px;
    }

    .single_medal .exchange {
        width: 100px;
        height: 36px;
        position: absolute;
        bottom: 20vmax;
        left: 50%;
        -webkit-transform:translateX(-50%);
        border-radius: 18px;
        -webkit-border-radius: 18px;
        -moz-border-radius: 18px;
        font-size: 16px;
        text-align: center;
        line-height: 36px;
        z-index: 1000;
    }
    .can_exchange {
        color: white;
        font-weight: bold;
        background-color: #FFAA00;
    }
    .cannot_exchange {
        color: #999999;
        font-weight: normal;
        background-color: #141414;
    }

    .exchange_sucess {
        position:fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width:100%;
        height: 100%;
        z-index:9999;
        background-color: #000000e2;
    }
    .exchange_sucess .div_icon {
        margin-top: 25vmax;
        margin-bottom: 10px;
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .exchange_sucess .div_icon .icon {
        width: 150px;
        height: 150px;
    }
    .exchange_sucess .text {
        width: 100%;
        margin-top: 20px;
        color: white;
        font-size: 17px;
        text-align: center;
    }

</style>